// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { getCurrentUserID, getUsers } from './getUsers';

export const getHasFamily = createSelector(getUsers, getCurrentUserID, (users, currentUserID) => {
  return users.some((u) => u.id !== currentUserID);
});

export default getHasFamily;
